import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Subject } from 'rxjs';

@Component({
  selector: 'app-option',
  template: `
    <div class="option" (click)="fireClickEvent()">
      <ng-content />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./option.component.scss'],
})
export class OptionComponent {
  readonly value = input<string>('');

  readonly optionClicked = output<void>();

  click$: Subject<string> = new Subject<string>();

  fireClickEvent(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.optionClicked.emit();
    this.click$.next(this.value());
  }
}
